import Model, { attr, hasMany } from "@ember-data/model";
import type MedicationMolecule from "parog-web/models/medication-molecule";

export default class MedicationTherapeuticalGroup extends Model {
  @hasMany("medication-molecule", {
    async: false,
    inverse: "medicationTherapeuticalGroup"
  })
  declare medicationMolecules: MedicationMolecule[];
  //---- End of generated code ----
  @attr("string") declare name: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medication-therapeutical-group": MedicationTherapeuticalGroup;
  }
}
